import http from "../core/http";
const group = 'drawEvents';

export const getDataListRequest =  async (data) => {
    return await http.post(`${group}/get`, data).then(res => res.data).catch(http.defaultCatch);
}

export const isDisplayedRequest =  async (data) => {
    return await http.post(`${group}/isDisplayed`, data).then(res => res.data).catch(http.defaultCatch);
}

export const createDataRequest =  async (data) => {
    return await http.post(`${group}/create`, data).then(res => res.data).catch(http.defaultCatch);
}

export const updateDataRequest =  async (data) => {
    return await http.post(`${group}/update`, data).then(res => res.data).catch(http.defaultCatch);
}

export const deleteDataRequest =  async (data) => {
    return await http.post(`${group}/delete`, data).then(res => res.data).catch(http.defaultCatch);
}

export const drawRequest =  async (data) => {
    return await http.post(`${group}/draw`, data).then(res => res.data).catch(http.defaultCatch);
}
export const getQuizListRequest =  async (data) => {
	return await http.post(`${group}/getQuizList`, data).then(res => res.data).catch(http.defaultCatch);
}
export const getUserList =  async (data) => {
	return await http.post(`${group}/getUserList`, data).then(res => res.data).catch(http.defaultCatch);
}
